import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Breadcrumbs,
  Typography,
  TextField,
  Container,
  Grid,
  Box,
  MenuItem,
  IconButton,
  Pagination,
  useMediaQuery,
  Checkbox,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { getName } from "../Other/common";
import { toast } from "react-toastify";
import { useTheme } from "@emotion/react";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";

import { menuSectionsTwo } from "../menuSectionsTwo";
import { BASE_URL } from "../../urlConfig/Url";

const UserRoleMaster = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [plantCode, setPlantCode] = useState("");
  const [email, setEmail] = useState("");
  const [id, setID] = useState("");
  const [hhtAcssess, setHhtAcssess] = useState("");
  const [userRole, setUserRole] = useState([]);
  const [userType, setUserType] = useState("");
  const [upadteBy, setUpdate] = useState("");

  const [companies, setCompanies] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);

  const [formMode, setFormMode] = useState("initial");

  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    fetchCompanies();
  }, []);

  const fetchCompanies = async () => {
    try {
      const response = await axios.post(BASE_URL + "/api/role/getUserRoleAll");
      if (response.data.success) {
        setCompanies(response.data.response);
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };

  const onSubmit = async () => {
    // Filter out any empty strings and trim each role
    const cleanedUserRole = userRole
      .filter((role) => role.trim() !== "")
      .map((role) => role.trim());

    const data = {
      userRole: userType,
      webAcssess: cleanedUserRole.join(","), // Join the cleaned array
      hhtAccess: hhtAcssess,
      updateBy: getName().Name,
    };
    // console.log(data);
    try {
      const response = await axios.post(
        BASE_URL + "/api/role/isertUserRole",
        data
      );

      if (response.data.success) {
        toast.success(response.data.message);
        fetchCompanies();
        resetForm();
        setFormMode("initial");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error submitting company data:", error);
      toast.error("An error occurred while adding the company.");
    }
  };

  const onUpdate = async () => {
    // Filter out any empty strings and trim each role
    const cleanedUserRole = userRole
      .filter((role) => role.trim() !== "")
      .map((role) => role.trim());

    const data = {
      id: id,
      userRole: userType,
      webAcssess: cleanedUserRole.join(","), // Join the cleaned array
      hhtAccess: hhtAcssess,
      updateBy: getName().Name,
    };
    // console.log(data);
    try {
      const response = await axios.post(
        BASE_URL + "/api/role/updateUserRole",
        data
      );

      if (response.data.success) {
        toast.success(response.data.message);
        fetchCompanies();
        resetForm();
        setFormMode("initial");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error updating company data:", error);
      toast.error("An error occurred while updating the company.");
    }
  };

  const resetForm = () => {
    setID("");
    setUserRole([]); // Reset to an empty array
    setUserType("");
    setPlantCode("");
    setEmail("");
  };

  const handleAddNew = () => {
    setFormMode("add");
    resetForm();
  };

  const handleCancel = () => {
    resetForm();
    setFormMode("initial");
  };

  useEffect(() => {
    const result = companies.filter((company) =>
      Object.entries(company).some(([key, value]) => {
        // Skip null or undefined values
        if (value == null) return false;

        // Convert to string and compare
        return value
          .toString()
          .toLowerCase()
          .includes(searchTerm.toLowerCase());
      })
    );
    setFilteredRows(result);
  }, [searchTerm, companies]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setPage(1);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowSelect = (company) => {
    setPlantCode(company.PlantCode);
    setEmail(company.EmailID);
    setID(company.U_ID);
    setUserType(company.UserType);
    setHhtAcssess(company.HHT_MenuAccess);

    // Parse the Web_MenuAccess string into an array of individual role values
    const roleArray = company.Web_MenuAccess
      ? company.Web_MenuAccess.split(",").map((role) => role.trim())
      : [];
    setUserRole(roleArray);
    setFormMode("edit");
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const paginatedRows = filteredRows.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );
  return (
    <>
      <Container maxWidth={isMobile ? "xs" : "lg"}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12}>
            <Box sx={{ mt: 1, mb: 2 }}>
              <Breadcrumbs aria-label="breadcrumb">
                <Link
                  to="/dashboard/dashbordhome"
                  style={{
                    textDecoration: "none",
                    color: theme.palette.primary.main,
                  }}
                >
                  Home
                </Link>
                <Typography color="textPrimary">User Role Master</Typography>
              </Breadcrumbs>
            </Box>

            <Paper elevation={3} sx={{ padding: "2%" }}>
              <Typography variant="h6" mb={2} sx={{ textAlign: "left" }}>
                User Role Master (* Fields Are Mandatory)
              </Typography>

              <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="User Role (*)"
                    name="User Role"
                    fullWidth
                    size="small"
                    value={userType}
                    onChange={(e) => setUserType(e.target.value)}
                    disabled={formMode === "initial"}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth margin="normal" size="small">
                    <InputLabel id="user-role-label">Web MenuAccess</InputLabel>
                    <Select
                      labelId="user-role-label"
                      multiple
                      value={userRole}
                      onChange={(e) => {
                        const newValues = e.target.value.filter(
                          (role) => role.trim() !== ""
                        );
                        setUserRole(newValues);
                      }}
                      label="Web MenuAccess"
                      renderValue={(selected) =>
                        selected.filter((role) => role.trim() !== "").join(", ")
                      }
                      disabled={formMode === "initial"}
                    >
                      {menuSectionsTwo.flatMap((section) =>
                        section.items.map((item) => (
                          <MenuItem key={item.role} value={item.role}>
                            <Checkbox checked={userRole.includes(item.role)} />
                            {item.text}
                          </MenuItem>
                        ))
                      )}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container justifyContent="flex-end" mt={5} spacing={1}>
                {formMode === "initial" && (
                  <Grid item>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleAddNew}
                    >
                      <AddIcon />
                      Add New
                    </Button>
                  </Grid>
                )}

                {formMode === "add" && (
                  <>
                    <Grid item>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={onSubmit}
                      >
                        <AddIcon />
                        Submit
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={handleCancel}
                      >
                        <CloseIcon />
                        Cancel
                      </Button>
                    </Grid>
                  </>
                )}

                {formMode === "edit" && (
                  <>
                    <Grid item>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={onUpdate}
                      >
                        <ChangeCircleIcon />
                        Update
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={handleCancel}
                      >
                        <CloseIcon />
                        Cancel
                      </Button>
                    </Grid>
                  </>
                )}
              </Grid>
            </Paper>

            {/* Table section */}
            <Paper elevation={3} sx={{ padding: "2%", mt: 3 }}>
              <Box
                sx={{
                  mb: 2,
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  justifyContent: "space-between",
                  alignItems: isMobile ? "stretch" : "center",
                  gap: 2,
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  sx={{ minWidth: 100 }}
                >
                  <InputLabel id="rows-per-page-label">
                    Rows per page
                  </InputLabel>
                  <Select
                    labelId="rows-per-page-label"
                    value={rowsPerPage}
                    onChange={handleChangeRowsPerPage}
                    label="Rows per page"
                  >
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                  </Select>
                </FormControl>
                <TextField
                  label="Search"
                  variant="outlined"
                  size="small"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  sx={{ width: isMobile ? "100%" : 250 }}
                  InputProps={{
                    endAdornment: (
                      <IconButton>
                        <SearchIcon />
                      </IconButton>
                    ),
                  }}
                />
              </Box>

              <Box
                sx={{
                  overflowX: "auto",
                  maxWidth: "100%",
                }}
              >
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Select</TableCell>
                      <TableCell>User Type</TableCell>
                      <TableCell>Web MenuAccess</TableCell>
                      <TableCell>HHT MenuAccess</TableCell>
                      <TableCell>Created By</TableCell>
                      <TableCell>Created Date</TableCell>
                      <TableCell>Updated By</TableCell>
                      <TableCell>Updated Date</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedRows.map((company) => (
                      <TableRow key={company.U_ID}>
                        <TableCell>
                          <Button
                            size="small"
                            onClick={() => handleRowSelect(company)}
                          >
                            Select
                          </Button>
                        </TableCell>
                        <TableCell>{company.UserType}</TableCell>
                        <TableCell>{company.Web_MenuAccess}</TableCell>
                        <TableCell>{company.HHT_MenuAccess}</TableCell>
                        <TableCell>{company.CreatedBy}</TableCell>
                        <TableCell>
                          {new Date(company.CreatedDate).toLocaleString()}
                        </TableCell>
                        <TableCell>{company.UpdatedBy}</TableCell>
                        <TableCell>
                          {company.UpdatedDate
                            ? new Date(company.UpdatedDate).toLocaleString()
                            : ""}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>

              <Box
                sx={{
                  mt: 2,
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  justifyContent: "space-between",
                  alignItems: isMobile ? "stretch" : "center",
                  gap: 2,
                }}
              >
                <Typography variant="body2">
                  Showing {(page - 1) * rowsPerPage + 1} to{" "}
                  {Math.min(page * rowsPerPage, filteredRows.length)} of{" "}
                  {filteredRows.length} entries
                </Typography>
                <Pagination
                  count={Math.ceil(filteredRows.length / rowsPerPage)}
                  page={page}
                  onChange={handleChangePage}
                  size="small"
                />
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default UserRoleMaster;
